__turbopack_context__.v({
  "root": "GetStartedButton-module__CoBXGa__root" + " " + __turbopack_context__.i(931616)["ctaTypeStyle"],
  "sent": "GetStartedButton-module__CoBXGa__sent",
});
